import NameStep from './name-step'
import { CreateInviteStepType } from 'types'

export const createInviteSteps: CreateInviteStepType[] = [
  { component: <NameStep />, fields: ['name'], hasNextButton: false },
]
